import { canPerform, normalizedRoles } from '@bayesprep/shared-ui/workflow';
const policies = {
  questions: 'CONTENT_READ', kits: 'KIT_MANAGE',
  'questions/create': 'AUTHOR_WRITE', 'questions/bulk-upload': 'AUTHOR_WRITE',
  'assigned-work': 'AUTHOR_WRITE', 'my-questions': 'AUTHOR_WRITE', tags: 'AUTHOR_WRITE',
  'questions-for-review': 'REVIEW_DECIDE', 'assigned-questions': 'REVIEW_DECIDE', 'completed-reviews': 'REVIEW_DECIDE',
  'draft-questions': 'CONTENT_COORDINATE', workflow: 'CONTENT_COORDINATE', publishing: 'PUBLISH',
  analytics: 'CONTENT_ANALYTICS', team: 'PLATFORM_MANAGE', users: 'PLATFORM_MANAGE', 'users/create': 'PLATFORM_MANAGE',
  'institution-access': 'PLATFORM_MANAGE',
  admins: 'PLATFORM_MANAGE', analysts: 'PLATFORM_MANAGE', 'super-admins': 'PLATFORM_MANAGE', tenants: 'PLATFORM_MANAGE', 'tenants/setup': 'PLATFORM_MANAGE',
  health: 'PLATFORM_MANAGE', settings: 'PLATFORM_MANAGE', 'test-configurations': 'PLATFORM_MANAGE', 'uuid-helper': 'PLATFORM_MANAGE'
};
export const canAccessRoute = (user, path) => {
  const route = path.replace(/^\//, '');
  if (route === 'dashboard') return normalizedRoles(user).some(role => ['SUPER_ADMIN','CONTENT_GENERATOR','CONTENT_REVIEWER','CONTENT_SUPERVISOR','ANALYST'].includes(role));
  return canPerform(user, policies[route]);
};
// Task groups stay the same for every account; capabilities only filter items.
export const navigationGroups = [
  { id: 'my-work', title: 'My Work', items: [
    { title: 'Overview', path: '/dashboard' },
    { title: 'My Drafts', path: '/my-questions' },
    { title: 'My Assigned Work', path: '/assigned-work' },
  ] },
  { id: 'question-bank', title: 'Question Bank', items: [
    { title: 'Published Questions', path: '/questions' },
    { title: 'All Unpublished Questions', path: '/workflow' },
    { title: 'Kits', path: '/kits' },
  ] },
  { id: 'review-publishing', title: 'Review & Publishing', items: [
    { title: 'Review Queue', path: '/questions-for-review' },
    { title: 'My Review Decisions', path: '/completed-reviews' },
    { title: 'Publishing Queue', path: '/publishing' },
  ] },
  { id: 'reporting', title: 'Reporting', items: [
    { title: 'Analytics', path: '/analytics' },
  ] },
  { id: 'administration', title: 'Administration', items: [
    { title: 'Accounts & Roles', path: '/users' },
    { title: 'Institution Access', path: '/institution-access' },
    { title: 'Institutions', path: '/tenants' },
    { title: 'Institution Admins', path: '/admins' },
    { title: 'System Health', path: '/health' },
    { title: 'Platform Settings', path: '/settings' },
  ] },
];
export const taskNavigation = navigationGroups.flatMap(group => group.items);
export const visibleNavigationGroups = user => navigationGroups
  .map(group => ({ ...group, items: group.items.filter(item => canAccessRoute(user, item.path)) }))
  .filter(group => group.items.length > 0);

// Keep authoring and existing deep links highlighted in their owning task group.
export const activeNavigationPath = pathname => ({
  '/questions/create': '/my-questions', '/questions/bulk-upload': '/my-questions', '/tags': '/my-questions',
  '/assigned-questions': '/questions-for-review', '/draft-questions': '/workflow',
  '/test-configurations': '/settings', '/uuid-helper': '/settings',
  '/team': '/users', '/analysts': '/users', '/super-admins': '/users',
  '/tenants/setup': '/tenants',
}[pathname.replace(/\/$/, '')] || pathname);
